module.exports = __webpack_public_path__ + "assets/bulb-gray-b6e3c245b19c9c1ee85d23b3bd38b15f.png";